
import { useState } from 'react';

export const useHoverState = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [likeButtonRef, setLikeButtonRef] = useState<HTMLElement | null>(null);
  
  return {
    isHovered,
    setIsHovered,
    likeButtonRef,
    setLikeButtonRef
  };
};
